import { useMemo } from "react";
import { object } from "yup";

export default function useValidationSchema() {
    return useMemo(() =>
        object().shape({})
        , []);
};
